import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import * as React from 'react';
import { CustomerSegmentType } from 'src/stores/SsoStore';
import { ISelectorItemProps, Selector } from 'telia-front-react';

interface ComponentProps {
  customerType: CustomerSegmentType;
  onChange: (type: CustomerSegmentType) => void;
}

const CustomerTypeSelector = observer((props: ComponentProps): React.JSX.Element => {
  const { customerType, onChange } = props;
  const { translate } = useContext(TranslationsContext);

  const options: ISelectorItemProps[] = [
    {
      id: 'B2C',
      name: 'segment',
      value: 'B2C',
      label: translate('reservation.customerType.B2C'),
    },
    {
      id: 'B2B',
      name: 'segment',
      value: 'B2B',
      label: translate('reservation.customerType.B2B'),
    },
  ];

  return (
    <Selector
      id="customer-type-selector"
      hideLabel={true}
      label={translate('reservation.customerType.select')}
      value={customerType}
      items={options}
      onChange={(value) => onChange(value as CustomerSegmentType)}
    />
  );
});

export default CustomerTypeSelector;
